module.exports = __webpack_public_path__ + "img/579.a2767c3f.jpg";